module.exports = __webpack_public_path__ + "img/31.f78e44f9.jpg";